<template>
  <v-container fluid class="marketproject-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Marketing Project</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Project</p>
                        <v-select
                          class="mb-4"
                          :items=marketprojecttype
                          v-model="marketproject.projecttype"
                          v-bind:error="error == 'projecttype'"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the project type">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="marketproject.projectname"
                          v-bind:error="error == 'projectname'"
                          outlined
                          dense
                          placeholder="Project Name"
                          persistent-hint
                          single-line hint="Enter the project name">
                        </v-text-field>


                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="pages.map(x => {return {text: x.pagename, value: x._id};})"
                          v-model="marketproject.pageid"
                          outlined
                          dense
                          placeholder="Page"
                          persistent-hint
                          single-line hint="Please choose the page">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="marketproject.ad_account_id"
                          outlined
                          dense
                          placeholder="Ad Account Id"
                          persistent-hint
                          single-line hint="Enter the ad account id">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items="locations.filter(location=>location.locationstatus=='Active').map(x => {return {text: x.locationname, value: x._id};})"
                          v-model="marketproject.locationid"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>

                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="brands.filter(brand=>brand.brandstatus=='Active' && brand.brandtype=='Brand').map(x => {return {text: x.brandname, value: x._id}})"
                          v-model="marketproject.brandid"
                          v-bind:error="error == 'brandid'"
                          outlined
                          dense
                          placeholder="Brand"
                          persistent-hint
                          single-line hint="Please choose the brand">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="data_users.filter(user=>user.userstatus=='Active').map(x => {return {text: `${x.username} (${x.companycode})`, value: x._id}})"
                          v-model="marketproject.repid"
                          v-bind:error="error == 'repid'"
                          outlined
                          dense
                          placeholder="Marketing Rep"
                          persistent-hint
                          single-line hint="Please choose the marketing rep">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="data_users.filter(user=>user.userstatus=='Active').map(x => {return {text: `${x.username} (${x.companycode})`, value: x._id}})"
                          v-model="marketproject.approverid"
                          v-bind:error="error == 'approverid'"
                          outlined
                          dense
                          placeholder="Approver"
                          persistent-hint
                          single-line hint="Please choose the approver">
                        </v-select>
                      </v-form>
                    </v-col>                                     
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/marketproject/team/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertMarketProject()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      error: undefined,
      errortag: false,
      errorindex: undefined,
      imageurl: undefined,
      menu_marketprojectdate: false,
      step: 1,
      pages: [],
      data_users: [],
      marketproject: {},
      marketprojecttype: ['Branding Project', 'Digital Project', 'Other Project'],
    }
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Location', ['locations']),
    ...mapState('MarketPlatform', ['platforms']),
    ...mapState('MarketProject', ['isReceiving']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('MarketPlatform', ['getMarketPlatformsRequest']),
    ...mapActions('MarketProject', ['getMarketProjects', 'insertMarketProjectRequest', 'insertMarketProjectWithImageRequest']),
    ...mapActions('User', ['getUsersMarketProjectRequest']),
    checkError(){
      if(!this.marketproject.projecttype){
        this.error = 'projecttype';
        return false;
      }
      if(!this.marketproject.projectname){
        this.error = 'projectname';
        return false;
      }
      if(!this.marketproject.brandid){
        this.error = 'brandid';
        return false;
      }
      if(!this.marketproject.repid){
        this.error = 'repid';
        return false;
      }
      if(!this.marketproject.approverid){
        this.error = 'approverid';
        return false;
      }
      this.error = null;
      this.step = 2;
      return true;
    },
    async insertMarketProject() {
      if(this.marketproject.imagefile!=null) await this.insertMarketProjectWithImageRequest(this.marketproject);
      else await this.insertMarketProjectRequest(this.marketproject);
      router.push('/marketproject/team/list');
    },
    onFileChange(file) {
      if (!file) {return;}
      this.marketproject.imagefile = file;
      this.marketproject.imagename = file.name;
      this.createImage(file);
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    },
  },
  async created () {
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.platforms.length==0) await this.getMarketPlatformsRequest();
    this.data_users = await this.getUsersMarketProjectRequest();


    for(var platform of this.platforms){
      this.pages = [...this.pages, ...platform.pages];
    }
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
